var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import NavigationService from "@ane/core/lib/services/NavigationService";
import { ROUTES } from "./Routes.constants.js";
class Util {
  constructor() {
    __publicField(this, "_modulePath", ROUTES.gar.root.match.path);
    __publicField(this, "_modulePathname", ROUTES.gar.root.location.pathname);
    __publicField(this, "routes", {
      root: {
        path: () => `${this.path}`,
        getURL: (payload) => {
          var _a;
          const stepId = payload.stepId;
          const pivot = (_a = payload.pivot) != null ? _a : this.defaultPivot;
          return `${this.url}/id/analysis-results/${stepId}/${pivot}`;
        },
        getURLWithTC: (payload) => {
          var _a;
          const stepId = payload.stepId;
          const treatment = payload.treatment;
          const control = payload.control;
          const pivot = (_a = payload.pivot) != null ? _a : this.defaultPivot;
          return `${this.url}/id/analysis-results/${stepId}/${pivot}?control=${control}&treatment=${treatment}`;
        },
        getURLWithTCAndMMFiltering: (payload) => {
          var _a;
          const highlight = payload.highlight;
          const stepId = payload.stepId;
          const pivot = (_a = payload.pivot) != null ? _a : this.defaultPivot;
          const treatment = payload.treatment;
          const control = payload.control;
          const metricName = payload.metricName;
          const effect = payload.effect;
          const pDifference = payload.pDifference;
          const insight = payload.insight;
          const scorecard = payload.scorecard;
          const analysisType = payload.analysisType;
          const analysisName = payload.analysisName;
          const category = payload.category;
          const query = payload.query;
          var url = `${this.url}/id/analysis-results/${stepId}/${pivot}?control=${control}&treatment=${treatment}`;
          if (metricName !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "metricName",
              value: `${metricName}`
            });
          }
          if (effect !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "effect",
              value: `${effect}`
            });
          }
          if (pDifference !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "pDifference",
              value: `${pDifference}`
            });
          }
          if (insight !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "insight",
              value: `${insight}`
            });
          }
          if (scorecard !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "scorecard",
              value: `${scorecard}`
            });
          }
          if (analysisType !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "analysisType",
              value: `${analysisType}`
            });
          }
          if (analysisName !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "analysisName",
              value: `${analysisName}`
            });
          }
          if (category !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "category",
              value: `${category}`
            });
          }
          if (query !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "query",
              value: `${query}`
            });
          }
          if (highlight !== void 0) {
            url = NavigationService.addParamToPath({
              url,
              param: "highlight",
              value: `${highlight}`
            });
          }
          return url;
        }
      },
      list: {
        path: () => `${NavigationService.root.path}${ROUTES.gar.list.match.path}`,
        url: (payload) => {
          const { stepId, studyId, scorecardId } = payload;
          if (!stepId) {
            return "";
          }
          let path = `${this.url}/id/analysis-results/${stepId}`;
          const params = [];
          if (studyId) {
            params.push(`highlight=${studyId}`);
          }
          if (scorecardId) {
            params.push(`scorecardId=${scorecardId}`);
          }
          const pivot = "scorecards";
          path += `/${pivot}`;
          if (params.length) {
            path += `?${params.join("&")}`;
          }
          return `${path}`;
        }
      },
      view: {
        path: () => `${NavigationService.root.path}${ROUTES.gar.view.match.path}`,
        url: (payload) => {
          const { stepId, studyId, taskId, taskPivot, scorecardId, showParameters, treatment, control } = payload;
          if (!stepId) {
            return "";
          }
          const pathParts = [`${this.url}/id/analysis-results/${stepId}${ROUTES.gar.view.location.pathname}`];
          if (studyId) {
            pathParts.push(`study/${studyId}`);
            if (taskId) {
              pathParts.push(`task/${taskId}`);
              if (taskPivot) {
                pathParts.push(taskPivot);
              }
            }
          }
          if (showParameters) {
            pathParts.push(`parameters`);
          }
          let fullPath = pathParts.join("/");
          if (!!control && !!treatment)
            fullPath += `?control=${control}&treatment=${treatment}`;
          return fullPath;
        }
      },
      create: {
        path: () => `${NavigationService.root.path}${ROUTES.gar.create.match.path}`,
        url: (payload) => {
          const { stepId } = payload;
          return `${this.url}/id/analysis-results/${stepId}${ROUTES.gar.create.location.pathname}`;
        }
      },
      clone: {
        path: () => `${NavigationService.root.path}${ROUTES.gar.clone.match.path}`,
        url: (payload) => {
          const { stepId, studyId } = payload;
          return `${this.url}/id/analysis-results/${stepId}${ROUTES.gar.clone.location.pathname}/${studyId}/clone`;
        }
      },
      scorecardTask: {
        path: () => `${NavigationService.root.path}${ROUTES.gar.scorecardTask.match.path}`,
        url: (payload) => {
          const { scorecardId } = payload;
          return `${this.url}/id/analysis-results${ROUTES.gar.scorecardTask.location.pathname}/${scorecardId}`;
        }
      }
    });
  }
  get defaultPivot() {
    return "scorecards";
  }
  /**
   * React Router regex path
   */
  get path() {
    return `${NavigationService.root.path}${this._modulePath}`;
  }
  /**
   * Pathname used to construct complete URL
   */
  get url() {
    return `${NavigationService.root.url}${this._modulePathname}`;
  }
}
const GarRouteUtils = new Util();
export {
  GarRouteUtils
};
//# sourceMappingURL=GuidedAnalysisResultsRoute.utils.js.map
